import { jsx as _jsx } from "react/jsx-runtime";
import { Checkbox, Typography, WithInfoIcon } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import styles from './SignatoryCheckbox.module.scss';
const SignatoryCheckbox = (param)=>{
    let { info, value, onChange, disabled = false, disableInfoIcon, checkboxTestId = 'required-sign', infoTestId = 'required-sign-info' } = param;
    const { t: texts } = useLocaleKeys('components.agreementStudio');
    return /*#__PURE__*/ _jsx(WithInfoIcon, {
        showInfo: !disableInfoIcon,
        infoTestId: infoTestId,
        info: info,
        className: styles.signatoryCheckbox,
        children: /*#__PURE__*/ _jsx(Checkbox, {
            testId: checkboxTestId,
            onChange: onChange,
            checked: value,
            disabled: disabled,
            bi: {
                name: 'required_to_sign'
            },
            children: /*#__PURE__*/ _jsx(Typography, {
                noWrap: true,
                children: texts.requiredToSign()
            })
        })
    });
};
export default SignatoryCheckbox;
